<template>
  <div class="relative">
    <div ref="googleMap" :style="fullSize"></div>
    <Icon
      src="material/clear"
      v-if="this.isReadable === 'true' && !!selectedPolygon"
      @click="deletePolygon"
      class="delete-polygon"
      title="Delete"
    />
  </div>
</template>

<script>
import Icon from '@wizer/core/components/icon/Icon'
import IframeMixin from '@/mixins/IframeMixin'
import LocationMapMixin from '@/mixins/LocationMapMixin'
import PolylineHelper from '@/utils/PolylineHelper'

export default {
  name: 'LocationMapPolygonDraw',
  components: {
    Icon,
  },

  mixins: [LocationMapMixin, IframeMixin],

  props: {
    latitude: String,
    longitude: String,
    polygonSubformFieldId: String,
    isReadable: String,
  },

  data() {
    return {
      selectedPolygon: null,
      drawingManager: null,
    }
  },

  async mounted() {
    this.centre = this.getPosition(this.latitude, this.longitude)
    await this.initializeComponent()
    this.initDrawing()
  },

  methods: {
    initDrawing() {
      const drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingControl: false,
        polylineOptions: {
          draggable: this.isReadable === 'true',
          editable: this.isReadable === 'true',
        },
      })
      drawingManager.setMap(this.map)
      drawingManager.setDrawingMode('polyline')
      const self = this
      this.google.maps.event.addListener(this.map, 'tilesloaded', function load() {
        self.loadPolygon()
      })
      this.registerListener('polygon-loaded', (event) => {
        if (event.data.coordinates) {
          if (self.selectedPolygon) {
            self.selectedPolygon.setMap(null)
          }
          const polyline = new this.google.maps.Polyline({
            path: PolylineHelper.getPolyline(event.data.coordinates),
            editable: self.isReadable === 'true',
            draggable: self.isReadable === 'true',
          })
          polyline.setMap(this.map)
          drawingManager.setDrawingMode(null)
          self.selectedPolygon = polyline
          self.google.maps.event.addListener(polyline, 'dragend', function update() {
            self.drawPolygon(polyline)
          })
          self.google.maps.event.addListener(polyline, 'mouseup', function update() {
            self.drawPolygon(polyline)
          })
        }
      })
      this.google.maps.event.addListener(
        drawingManager,
        'polylinecomplete',
        function drawn(polyline) {
          self.selectedPolygon = polyline
          self.google.maps.event.addListener(polyline, 'dragend', function update() {
            self.drawPolygon(polyline)
          })
          self.google.maps.event.addListener(polyline, 'mouseup', function update() {
            self.drawPolygon(polyline)
          })
          drawingManager.setDrawingMode(null)
          self.drawPolygon(polyline)
        },
      )
      this.drawingManager = drawingManager
    },

    /**
     * Adds a new polygon to map
     * @param {object} latLng position to process
     */
    addPolygon(latLng) {
      this.relayEvent({
        event: `polygon-add`,
        centreLatitude: latLng.lat(),
        centreLongitude: latLng.lng(),
        initialZoom: this.map.zoom,
        initialMapTypeId: this.map.mapTypeId,
        polygonSubformFieldId: this.polygonSubformFieldId,
      })
    },

    deletePolygon() {
      if (this.selectedPolygon) {
        this.selectedPolygon.setMap(null)
        this.selectedPolygon = null
        this.drawingManager.setDrawingMode('polyline')
        this.relayEvent({
          event: 'polygon-delete',
          polygonSubformFieldId: this.polygonSubformFieldId,
          recordId: this.getRecordId(),
        })
      }
    },

    loadPolygon() {
      this.relayEvent({
        event: 'polygon-load',
        polygonSubformFieldId: this.polygonSubformFieldId,
        recordId: this.getRecordId(),
      })
    },

    drawPolygon(polyline) {
      this.relayEvent({
        event: 'polygon-drawn',
        coordinates: JSON.stringify(polyline.getPath().getArray()),
        recordId: this.getRecordId(),
      })
    },

    getRecordId() {
      return this.contextId.split('-bMs-')[0].replace('widget_', '')
    },
  },
}
</script>

<style scoped lang="postcss">
.delete-polygon {
  @apply absolute bg-white cursor-pointer text-3xl;
  top: 10px;
  right: 55px;
}
</style>
